// Skeleton.jsx
import React from "react";

export default function Skeleton({
    width = "100%",
    height = "1rem",
    borderRadius = 4,
    variant = "rect", // "rect" or "circle" or "text"
    animation = "pulse", // "pulse" | "shimmer" | "none"
    style = {},
    className = "",
    count = 1,
    ariaLabel = "Loading content",
}) {
    const baseStyle = {
        width,
        height,
        borderRadius: variant === "circle" ? "50%" : borderRadius,
        ...style,
    };

    const items = Array.from({ length: Math.max(1, count) });

    return (
        <div
            className={`skeleton-wrapper ${className}`}
            role="status"
            aria-busy="true"
            aria-label={ariaLabel}
        >
            {items.map((_, i) => (
                <span
                    key={i}
                    className={`skeleton ${animation} ${variant}`}
                    style={baseStyle}
                    aria-hidden="true"
                />
            ))}
        </div>
    );
}
